/* ============================================================
   ResearchScreen — the dedicated Market Research page at
   /app/research. Thin wrapper: loads the brand profile (intake
   source for manual runs) and hosts ResearchTab, which owns all
   states (empty / live progress / teaser / full report).
   ============================================================ */
import { useEffect, useState } from 'react';
import { api } from '../services/api/client.js';
import MarketingSubnav from '../components/MarketingSubnav.jsx';
import { ResearchTab } from './content-plan/ResearchTab.jsx';
import { toBrandForm } from './content-plan/shared/brandFormUtils.js';

export default function ResearchScreen() {
  const [brandProfile, setBrandProfile] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.profile.getBrandProfile()
      .then((res) => {
        if (!cancelled) setBrandProfile(toBrandForm(res?.brandProfile || (res?.data ?? res)?.brandProfile || {}));
      })
      .catch(() => {
        // No profile (or transient error) — ResearchTab still renders; the
        // worker inherits intake from a previous report when none is sent.
        if (!cancelled) setBrandProfile(null);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    // EXACTLY the same wrapper as ContentPlan (bare .cps-root): the extra
    // .page class carried its own max-width+padding and shrank the sub-nav
    // by 64px relative to the plan page — the strip visibly jumped on switch.
    <div className="cps-root">
      <MarketingSubnav />
      <ResearchTab brandProfile={brandProfile} />
    </div>
  );
}
